import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';
import _ from 'lodash';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

@inject('appStore')
@observer
export default class AgentSalesView extends Component {
    constructor(props) {
        super(props);
    }

    renderTableActions(cell, row) {
        return (
            <button
                style={{ marginRight: '10px' }}
                className="btn btn-default btn-sm"
                onClick={this.props.handleOpenProfile.bind(this, row)}
            >
                Profile
            </button>
        );
    }
    selectRowProp = {
        mode: 'checkbox',
        clickToSelect: true,
        hideSelectColumn: true,
        onSelect: this.props.handleClick,
    };
    options = {
        defaultSortName: 'subscriberName',
        defaultSortOrder: 'asc',
    };
    render() {
        return (
            <BootstrapTable
                selectRow={this.selectRowProp}
                options={this.options}
                ref="table"
                data={appStore.agentStore.combinedAgentsForAdmin}
            >
                <TableHeaderColumn dataField="agentContactId" isKey dataAlign="right" hidden>
                    agentContactId
                </TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataSort={true}>
                    Name
                </TableHeaderColumn>
                <TableHeaderColumn dataField="subscriberName" dataSort={true}>
                    Brokerage
                </TableHeaderColumn>
                <TableHeaderColumn width="20%" dataField="email">
                    Email
                </TableHeaderColumn>
                <TableHeaderColumn dataField="fileCoordinatorNames" dataFormat={cell => cell.join(', ')}>
                    TC
                </TableHeaderColumn>
                <TableHeaderColumn dataField="fileWatchCoordinatorNames" dataFormat={cell => cell.join(', ')}>
                    TC Watch
                </TableHeaderColumn>
                <TableHeaderColumn dataField="preferredEmail">Preferred Email</TableHeaderColumn>
                <TableHeaderColumn width="70px" dataFormat={this.renderTableActions.bind(this)}></TableHeaderColumn>
            </BootstrapTable>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sales/sales-agent-view.js